import { render, staticRenderFns } from "./breeder-bio-form-container.vue?vue&type=template&id=8497e9ba&scoped=true&lang=pug"
import script from "./breeder-bio-form-container.js?vue&type=script&lang=js&external"
export * from "./breeder-bio-form-container.js?vue&type=script&lang=js&external"
import style0 from "./breeder-bio-form-container.vue?vue&type=style&index=0&id=8497e9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8497e9ba",
  null
  
)

export default component.exports